export class GlobalState {
  enableDuckDuckGoBrowserIntegration?: boolean;
}
